import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as moment from 'moment-timezone';

import { AppState } from 'src';

import { AutoAuthoViewModel, SetTripStatusRequestViewModel } from '@services/AutoAuthoService';

import {
  getTripReasons,
  reset,
  selectSwoTripStatus,
  setAppointmentDate,
  setSetTripStatusFormDispatcher,
  setTripStatus
} from '../status-update.actions';
import { AutoAuthoStatusUpdateComponent, AutoAuthoStatusUpdateComponentProperties } from './status-update.component';

export interface AutoAuthoStatusUpdateProperties {
  readonly cancel: () => void;
  readonly phoneNumber: string;
  readonly swoId: number;
  readonly swoTripStatusMap?: object;
  readonly updateViewModel: (viewModel: AutoAuthoViewModel) => void;
  readonly viewModel: AutoAuthoViewModel;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: AutoAuthoStatusUpdateProperties
): Partial<AutoAuthoStatusUpdateComponentProperties> {
  return {
    appointmentDate: state.autoAutho.statusUpdate.appointmentDate,
    phoneNumber: ownProps.phoneNumber,
    selectedSwoTripStatus: state.autoAutho.statusUpdate.selectedSwoTripStatus,
    swoId: ownProps.swoId,
    swoTripStatusMap: ownProps.swoTripStatusMap,
    tripReasons: state.autoAutho.statusUpdate.tripReasons,
    tripStatusUpdated: state.autoAutho.statusUpdate.tripStatusUpdated,
    viewModel: ownProps.viewModel
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: AutoAuthoStatusUpdateProperties
): Partial<AutoAuthoStatusUpdateComponentProperties> {
  return {
    cancel: () => ownProps.cancel(),
    getTripReasons: (phoneNUmber: string, swoId: number) => dispatch(getTripReasons(phoneNUmber, swoId)),
    reset: () => dispatch(reset()),
    setAppointmentDate: (date: moment.Moment | null) => dispatch(setAppointmentDate(date)),
    selectSwoTripStatus: (status: number) => dispatch(selectSwoTripStatus(status)),
    setSetTripStatusFormDispatcher: (dispatcher: Function) => dispatch(setSetTripStatusFormDispatcher(dispatcher)),
    setTripStatus: (phoneNumber: string, swoId: number, request: SetTripStatusRequestViewModel) =>
      dispatch(setTripStatus(phoneNumber, swoId, request)),
    updateViewModel: (viewModel: AutoAuthoViewModel) => ownProps.updateViewModel(viewModel)
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const AutoAuthoStatusUpdate = connect(
  mapStateToProps,
  mapDispatchToProps
)(AutoAuthoStatusUpdateComponent);



// WEBPACK FOOTER //
// ./src/auto-autho/_components/status-update/_components/status-update.container.ts